/**
 * CJSUSPENSION model-page runtime fixes.
 * Keeps a small set of exact page behaviours stable after other shared
 * model-page scripts have finished their own sorting passes.
 */
(function () {
  'use strict';

  function normalise(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function currentPath() {
    return String(window.location.pathname || '').toLowerCase();
  }

  function fixGenieUpgradeOrder() {
    if (currentPath() !== '/pages/fox-specialized-genie') {
      return;
    }

    document.querySelectorAll('.cjs-model-upgrade-grid').forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.children).filter(function (child) {
        return child.classList && child.classList.contains('cjs-model-upgrade-card');
      });

      if (cards.length < 2) {
        return;
      }

      var tuningCard = null;
      var bumpStopCard = null;
      var others = [];

      cards.forEach(function (card) {
        var heading = card.querySelector('h3');
        var title = normalise(heading ? heading.textContent : '');

        if (title.indexOf('genie tuning kit') !== -1 && title.indexOf('bump stop') === -1) {
          tuningCard = card;
        } else if (title.indexOf('genie') !== -1 && title.indexOf('bump stop') !== -1) {
          bumpStopCard = card;
        } else {
          others.push(card);
        }
      });

      if (!tuningCard || !bumpStopCard) {
        return;
      }

      var desired = [tuningCard, bumpStopCard].concat(others);
      var changed = desired.some(function (card, index) {
        return cards[index] !== card;
      });

      if (!changed) {
        return;
      }

      desired.forEach(function (card) {
        grid.appendChild(card);
      });
    });
  }

  function fixCoilSpringSetupSecondaryButton() {
    document.querySelectorAll('.cjs-model-card').forEach(function (card) {
      var heading = card.querySelector('h3');
      var title = normalise(heading ? heading.textContent : '');

      if (title.indexOf('spring setup') === -1) {
        return;
      }

      if (card.querySelector('a[href="/collections/rear-shock-springs"], a[href$="/collections/rear-shock-springs"]')) {
        return;
      }

      var primaryButton = card.querySelector('a.cjs-model-button');
      if (!primaryButton) {
        return;
      }

      var secondaryButton = document.createElement('a');
      secondaryButton.className = 'cjs-model-button secondary';
      secondaryButton.href = '/collections/rear-shock-springs';
      secondaryButton.textContent = 'View Coil Springs';

      primaryButton.insertAdjacentElement('afterend', secondaryButton);
    });
  }

  function ensureAirVolumeSecondary(card, label, url) {
    if (!card || !url) {
      return;
    }

    var existing = card.querySelector('[data-cjs-air-volume-secondary]');
    if (existing) {
      existing.href = url;
      existing.textContent = label;
      return;
    }

    var primary = card.querySelector('a.cjs-model-button');
    if (!primary) {
      return;
    }

    var secondary = document.createElement('a');
    secondary.className = 'cjs-model-button secondary';
    secondary.href = url;
    secondary.textContent = label;
    secondary.setAttribute('data-cjs-air-volume-secondary', '');
    primary.insertAdjacentElement('afterend', secondary);
  }

  function fixAirVolumeSpacerCtas() {
    var path = currentPath();
    var productConfig = null;

    if (
      path === '/pages/cane-creek-air-il' ||
      path === '/pages/cane-creek-dbair' ||
      path === '/pages/cane-creek-kitsuma-air'
    ) {
      productConfig = {
        label: 'View Cane Creek Air Volume Spacers',
        url: '/products/cane-creek-air-volume-spacers'
      };
    } else if (path === '/pages/marzocchi-bomber-air') {
      productConfig = {
        label: 'View Bomber Air Volume Spacers',
        url: '/products/marzocchi-bomber-air-volume-spacer-kits'
      };
    } else if (path === '/pages/dvo-topaz' || path === '/pages/dvo-topaz-gen-3') {
      productConfig = {
        label: 'View Topaz Volume Tuning Bands',
        url: 'https://dvo.nz/collections/shock-parts/products/dvo-topaz-volume-tuning-bands'
      };
    }

    if (!productConfig) {
      return;
    }

    document.querySelectorAll('.cjs-model-card').forEach(function (card) {
      var heading = card.querySelector('h3');
      var title = normalise(heading ? heading.textContent : '');

      if (title.indexOf('air volume spacer setup') === -1) {
        return;
      }

      ensureAirVolumeSecondary(card, productConfig.label, productConfig.url);
    });
  }

  var megaMenuModelPages = {
    'fox suspension': [
      ['32', '/pages/fox-32'],
      ['34', '/pages/fox-34'],
      ['36', '/pages/fox-36'],
      ['38', '/pages/fox-38'],
      ['40', '/pages/fox-40'],
      ['Podium', '/pages/fox-podium'],
      ['831', '/pages/fox-831'],
      ['Float', '/pages/fox-float'],
      ['Float SL', '/pages/fox-float-sl'],
      ['Float DPS', '/pages/fox-float-dps'],
      ['DPX2', '/pages/fox-dpx2'],
      ['Float X', '/pages/fox-float-x'],
      ['Float X2', '/pages/fox-float-x2'],
      ['DHX', '/pages/fox-dhx'],
      ['DHX2', '/pages/fox-dhx2'],
      ['DHX RC4 / RC2', '/pages/fox-dhx-rc4-rc2'],
      ['DHX Air 5.0 / 4.0 / 3.0', '/pages/fox-dhx-air-5-0-4-0-3-0'],
      ['DHX Coil 5.0 / 4.0 / 3.0', '/pages/fox-dhx-coil-5-0-4-0-3-0'],
      ['VAN R / RC', '/pages/fox-van-r-rc'],
      ['Vanilla', '/pages/fox-vanilla'],
      ['Float RP-Series', '/pages/fox-float-rp-series'],
      ['Float CTD', '/pages/fox-float-ctd'],
      ['Float X CTD', '/pages/fox-float-x-ctd'],
      ['Specialized GENIE', '/pages/fox-specialized-genie'],
      ['Brain Shock', '/pages/fox-brain-shock'],
      ['Transfer', '/pages/fox-transfer']
    ],
    'rockshox': [
      ['SID SL', '/pages/rockshox-sid-sl'],
      ['SID', '/pages/rockshox-sid'],
      ['Pike', '/pages/rockshox-pike'],
      ['Lyrik', '/pages/rockshox-lyrik'],
      ['ZEB', '/pages/rockshox-zeb'],
      ['BoXXer', '/pages/rockshox-boxxer'],
      ['Domain', '/pages/rockshox-domain'],
      ['Yari', '/pages/rockshox-yari'],
      ['Revelation', '/pages/rockshox-revelation'],
      ['Sektor', '/pages/rockshox-sektor'],
      ['Recon', '/pages/rockshox-recon'],
      ['Judy', '/pages/rockshox-judy'],
      ['Reba', '/pages/rockshox-reba'],
      ['35', '/pages/rockshox-35'],
      ['30', '/pages/rockshox-30'],
      ['Bluto', '/pages/rockshox-bluto'],
      ['Psylo', '/pages/rockshox-psylo'],
      ['XC-Series', '/pages/rockshox-xc-series'],
      ['RS-1', '/pages/rockshox-rs-1'],
      ['SIDLuxe', '/pages/rockshox-sidluxe'],
      ['Deluxe', '/pages/rockshox-deluxe'],
      ['Deluxe Coil', '/pages/rockshox-deluxe-coil'],
      ['Super Deluxe Air', '/pages/rockshox-super-deluxe'],
      ['Super Deluxe Coil', '/pages/rockshox-super-deluxe-coil'],
      ['Vivid Air', '/pages/rockshox-vivid-air'],
      ['Vivid Coil', '/pages/rockshox-vivid-coil'],
      ['Monarch', '/pages/rockshox-monarch'],
      ['Monarch Plus', '/pages/rockshox-monarch-plus'],
      ['Kage', '/pages/rockshox-kage'],
      ['Brain Shock', '/pages/rockshox-brain-shock'],
      ['Reverb', '/pages/rockshox-reverb'],
      ['Reverb AXS', '/pages/rockshox-reverb-axs']
    ],
    'öhlins': [
      ['RXC34', '/pages/ohlins-rxc34'],
      ['RXF34', '/pages/ohlins-rxf34'],
      ['RXF36', '/pages/ohlins-rxf36'],
      ['RXF38', '/pages/ohlins-rxf38'],
      ['DH38', '/pages/ohlins-dh38'],
      ['RXFDJ', '/pages/ohlins-rxfdj'],
      ['TXC1Air', '/pages/ohlins-txc1air'],
      ['TXC2Air', '/pages/ohlins-txc2air'],
      ['TTX1Air / TTX1Air m.2', '/pages/ohlins-ttx1air'],
      ['TTX2Air / TTX2Air m.2', '/pages/ohlins-ttx2air'],
      ['TTX22M / TTX22M.2', '/pages/ohlins-ttx22m'],
      ['STX22 Air', '/pages/ohlins-stx22-air']
    ],
    'marzocchi': [
      ['Bomber Z1 / Z1 Coil', '/pages/marzocchi-bomber-z1'],
      ['Bomber Z2', '/pages/marzocchi-bomber-z2'],
      ['Bomber 58', '/pages/marzocchi-bomber-58'],
      ['Bomber DJ', '/pages/marzocchi-bomber-dj'],
      ['Super Z', '/pages/marzocchi-super-z'],
      ['Bomber Z', '/pages/marzocchi-bomber-z'],
      ['380', '/pages/marzocchi-380'],
      ['350', '/pages/marzocchi-350'],
      ['888', '/pages/marzocchi-888'],
      ['66', '/pages/marzocchi-66'],
      ['55', '/pages/marzocchi-55'],
      ['Dirt Jumper', '/pages/marzocchi-dirt-jumper'],
      ['Bomber CR', '/pages/marzocchi-bomber-cr'],
      ['Bomber Air', '/pages/marzocchi-bomber-air'],
      ['Bomber Inline', '/pages/marzocchi-bomber-inline']
    ],
    'cane creek': [
      ['HELM', '/pages/cane-creek-helm'],
      ['HELM MKII', '/pages/cane-creek-helm-mkii'],
      ['Air IL / DBair IL / DBInline', '/pages/cane-creek-air-il'],
      ['Coil IL / DBcoil IL', '/pages/cane-creek-coil-il'],
      ['DBair / DBair CS', '/pages/cane-creek-dbair'],
      ['DBcoil / DBcoil CS', '/pages/cane-creek-dbcoil'],
      ['Kitsuma Air', '/pages/cane-creek-kitsuma-air'],
      ['Kitsuma Coil', '/pages/cane-creek-kitsuma-coil'],
      ['Tigon', '/pages/cane-creek-tigon']
    ],
    'dvo': [
      ['Onyx 38', '/pages/dvo-onyx-38'],
      ['Onyx SC / Onyx SC 36', '/pages/dvo-onyx-sc'],
      ['Onyx DC', '/pages/dvo-onyx-dc'],
      ['Diamond 35 / Diamond 36', '/pages/dvo-diamond'],
      ['Sapphire 32 / Sapphire 34', '/pages/dvo-sapphire'],
      ['Emerald', '/pages/dvo-emerald'],
      ['Beryl', '/pages/dvo-beryl'],
      ['Topaz', '/pages/dvo-topaz'],
      ['Topaz Gen 3 / Topaz Prime / newer Topaz', '/pages/dvo-topaz-gen-3'],
      ['Jade', '/pages/dvo-jade'],
      ['Jade X / Jade X Prime', '/pages/dvo-jade-x'],
      ['Opal', '/pages/dvo-opal']
    ]
  };

  function syncMegaMenuModelPages() {
    document.querySelectorAll('.cjs-brands-menu__brand').forEach(function (card) {
      var brandName = card.querySelector('.cjs-brands-menu__brand-name');
      var brand = normalise(brandName ? brandName.textContent : '');
      var entries = megaMenuModelPages[brand];
      var list = card.querySelector('.cjs-brands-menu__models');

      if (!entries || !list) {
        return;
      }

      var signature = entries.map(function (entry) {
        return entry[0] + '|' + entry[1];
      }).join('||');

      if (list.getAttribute('data-cjs-full-model-pages') === signature) {
        return;
      }

      list.textContent = '';

      entries.forEach(function (entry) {
        var item = document.createElement('li');
        var link = document.createElement('a');

        link.href = entry[1];
        link.textContent = entry[0];
        link.setAttribute('data-cjs-model-link', '');
        item.appendChild(link);
        list.appendChild(item);
      });

      list.setAttribute('data-cjs-full-model-pages', signature);
    });
  }

  function stripMegaMenuBrandPrefixes() {
    var prefixes = {
      'fox suspension': 'Fox ',
      'rockshox': 'RockShox ',
      'öhlins': 'Öhlins ',
      'marzocchi': 'Marzocchi ',
      'vorsprung': 'Vorsprung ',
      'cane creek': 'Cane Creek ',
      'dvo': 'DVO '
    };

    document.querySelectorAll('.cjs-brands-menu__brand').forEach(function (card) {
      var brandName = card.querySelector('.cjs-brands-menu__brand-name');
      var brand = normalise(brandName ? brandName.textContent : '');
      var prefix = prefixes[brand];

      if (!prefix) {
        return;
      }

      card.querySelectorAll('.cjs-brands-menu__models a').forEach(function (link) {
        var modelName = String(link.textContent || '').replace(/\s+/g, ' ').trim();

        if (brand === 'fox suspension' && modelName === 'Fox / Specialized GENIE') {
          link.textContent = 'Specialized GENIE';
          return;
        }

        if (modelName.indexOf(prefix) === 0) {
          link.textContent = modelName.slice(prefix.length);
        }
      });
    });
  }

  function run() {
    fixGenieUpgradeOrder();
    fixCoilSpringSetupSecondaryButton();
    fixAirVolumeSpacerCtas();
    syncMegaMenuModelPages();
    stripMegaMenuBrandPrefixes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function () {
    observer.disconnect();
    run();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();